import React, { Component } from 'react';
import {
  Loading,
  Button,
  Tabs,
  Tab,
  InlineNotification,
  TabsSkeleton,
  HeaderName,
  HeaderNavigation,
  SkeletonText,
} from 'carbon-components-react';
import { ChevronLeft16, Information16 } from '@carbon/icons-react';
import { ScrollingProvider, Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import '../../scss/react-datetime.css';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  STATUS,
} from '../../helpers/Constants';
import { api, dynamic, registry, me } from '../../helpers/api/api';
import ReportRepository from '../../helpers/api/ReportRepository';

import { IsInRole, IsEditable, CanExecuteAction } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import {
  CheckmarkOutline16,
  Send16,
  Delete16,
  Error16,
  InformationFilled16,
} from '@carbon/icons-react/lib/';
import { WFActionModal } from '../common/WFActionModal';
import IncidentTabNotification from './IncidentTabNotification';
import IncidentTabReport from './IncidentTabReport';
import IncidentTabInvestigation from './IncidentTabInvestigation';
import IncidentTabCauses from './IncidentTabCauses';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { HistoryTable } from '../../helpers/HistoryTable';
import IncidentRepository from '../../helpers/api/IncidentRepository';
import { Online, Offline } from '../common/OnLineOffLine';
import moment from 'moment';
import _sortBy from 'lodash/sortBy'; //RITM1143712

const initialState = {
  isEdit: false,
  isLoadingIncident: false,
  idIncidentEdit: undefined,
  incidentEditModel: null,
  isSubmitted: false,
  toSubmit: false,

  appActivity: [],
  appPublicAuthoritiesAndEntitiesInvolved: [],
  appTransportAccident: [],
  appInfoOriginator: [],
  subContractors: [],
  appWorkRelated: [],
  appPlace: [],
  appLifeSavingRuleCategory: [],
  appLifeSavingRule: [],
  appAllWorksites: null,
  appAllWorksitePrj: null,
  ///report///
  appCountry: [],
  appInjuryType: [],
  ///Status Action
  isApprovalModalOpen: false,
  approvalModalAction: '',
  approver: null,
  approvalStartDate: null,
  approvalEndDate: null,
  isLoadingApproverOptions: true,
  approvalValidationMessages: [],
  approvers: [],
  selectedData: [],
  approverRole: '',
  withApprover: true,
  isLoadingWFOperation: false,
  approvalNotesRequired: false,
  ///Status Action
  //History WF
  isHistoryModalOpen: false,
  //History WF
  appIncidentTypology: [], //RITM1143712
  appHighConsequenceLevels: [], //RITM1216061
  isConsolidationActionNo: false, //RITM1216061
  appRealPotentialConsequenceLevels: [], //RITM1405215
  PELFinalValue: null, //RITM1519246
  PHLFinalValue: null, //RITM1519246
};

export default class NewIncidentReport extends Component {
    constructor(props) {
        super(props);

        this.selectTab = this.selectTab.bind(this);

        let idIncidentEdit = this.props.match.params.id;

        this.state = {
            stateIcon: false,
            stateTabs: 0,
            ...initialState,
            idIncidentEdit,
            isLoadingIncident: idIncidentEdit != undefined,
            isDisabledAll: false,
            isAutoOpenInjuredPerson: false,//RITM0864430
        };
    }
    baseUrl = '/incident/';
    componentDidMount() {
        //this.getAllWorkSite(); //RITM1617862
        this.setStaticObject();
        this.getLifeSavingRule();
        this.getAllActivity();
        this.getCountry();
        this.getInjuryType();
        this.getIncidentTypology(); //RITM1143712
        this.getIncidentHighConsequenceLevel(); //RITM1216061
        this.getIncidentRealPotentialConsequenceLevel(); //RITM1405215
        if (this.state.idIncidentEdit != undefined) {
            this.getIncidentForEdit(this.state.idIncidentEdit);
        } else {
            this.getAllWorkSite(); //RITM1617862
            this.getAllWorkSitePrj('');
        }
    }
    showButtonHistory = () => {
        return (
            <Online>
                <Button
                    className="action-button-modal"
                    kind="secondary"
                    renderIcon={Information16}
                    onClick={() => this.openModalHistory()}
                >
                    History
        </Button>
            </Online>
        );
    };
    openModalHistory = () => {
        this.setState({ isHistoryModalOpen: true });
    };
    closeModalHistory = () => {
        this.setState({ isHistoryModalOpen: false });
    };
    selectTab(tabIndex) {
        this.setState({ stateTabs: tabIndex });
    }

    isSubmitted = (value) => {
        this.setState({ isSubmitted: value });
    };

    setlifeSavingRules = (value) => {
        if (this.state.incidentEditModel !== null
            & this.state.incidentEditModel !== undefined
            && this.state.incidentEditModel.tabNotifications !== null
            && this.state.incidentEditModel.tabNotifications !== undefined) {
            var obj = Object.assign(this.state.incidentEditModel.tabNotifications);
            obj['lifeSavingRules'] = value;

            this.setState((prevState) => ({
                toSubmit: false,
                incidentEditModel: {
                    ...prevState.incidentEditModel,
                    tabNotifications: obj,
                },
            }));
        }
    }

    showLoading() {
        let show = (this.state.isEdit && this.state.isLoadingIncident) || this.state.isSubmitted;
        let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
        return show && <Loading active={true} withOverlay={true} description={descr} />;
        //return (<InlineLoading className="bx--loading-overlay" {...props} />)
    }

    async getIncidentForEdit(id) {
        try {
            this.setState({
                isEdit: true,
                isLoadingIncident: true,
            });

            const response = await api.get(this.baseUrl, id);
            let data = response.data;
            if (data && data.tabNotifications && data.tabNotifications.id) {
                console.log('getIncidentForEdit(): data received!');
                this.setState({
                    idIncidentEdit: id,
                    incidentEditModel: data,
                    PHLFinalValue: this.state.appHighConsequenceLevels.find((el) => el.id == data?.tabNotifications?.incidentOutcomes?.find(out => out.idOutcome == 0)?.idHighConsequenceLevelPotentialFinal)?.ranking,
                    PELFinalValue: this.state.appHighConsequenceLevels.find((el) => el.id == data?.tabNotifications?.incidentOutcomes?.find(out => out.idOutcome == 2)?.idHighConsequenceLevelPotentialFinal)?.ranking,
                }); //RITM1519246
                console.log('getIncidentForEdit(): data.tabNotifications.idProject: ' + data.tabNotifications.idProject);
                await this.getAllWorkSite(data.tabNotifications.idWorksite) //RITM1617862
                await this.getAllWorkSitePrj(data.tabNotifications.idProject);

            } else {
                showNotification.error();
                this.cancel();
            }
            console.log('getIncidentForEdit(): end of try');
        } catch(error) {
            showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.GET));
            this.cancel();
        } finally {
            console.log('getIncidentForEdit(): finally');
            this.setState({ isLoadingIncident: false });
        }
    }

    async getAllWorkSite(currentIdWorkSite) { //RITM1617862
      this.setState({
            isLoadingIncident: true
        }); //RITM1617862
      await api
        .getAll('/me/worksites' + (currentIdWorkSite !== null && currentIdWorkSite !== undefined ? '?currentIdWorkSite=' + currentIdWorkSite : '')) //RITM1617862
        .then((response) => {
          var data = response.data;
          this.setState({
            appAllWorksites: data,
          });
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.WORKSITE, apioperation.GET)
          );
        })
        .finally(() => {
          this.setState(
                {
                    isLoadingIncident: false
                }
            ); //RITM1617862
        });
    }

    async getAllWorkSitePrj(currentIdProject) {
        this.setState({
            isLoadingIncident: true
        });
      console.log('getAllWorkSitePrj(): currentIdProject: ' + currentIdProject);
    await api
        .getAll('/me/worksitesproject' + (currentIdProject != '' ? '?currentIdProject=' + currentIdProject + '&inUse=false' : '')) //RITM1617862
        .then((response) => {
            console.log('getAllWorkSitePrj(): response received!');
            var data = response.data;
            this.setState({
                appAllWorksitePrj: data
            });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKSITEPROJECT, apioperation.GET)
        );
      })
        .finally(() => {
            console.log('getAllWorkSitePrj(): finally');
            this.setState(
                {
                    isLoadingIncident: false
                }
            );
        });
  }

  getCountry() {
    api
      .getAll('/country')
      .then((response) => {
        var data = response.data;
        this.setState({
          appCountry: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.COUNTRY, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getAllActivity() {
    api
      .getAll('/activity')
      .then((response) => {
        var data = response.data;
        this.setState({
          appActivity: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ACTIVITY, apioperation.GET)
        );
      })
      .finally(() => {});
  }

  getLifeSavingRule = () => {
    dynamic
      .getAll('lifesavingrule', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appLifeSavingRule: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.LIFESAVINGRULEVIOLATION, apioperation.GET)
        );
      })
      .finally(() => {});

    dynamic
      .getAll('lifesavingrulecategory', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appLifeSavingRuleCategory: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.LIFESAVINGRULEVIOLATION, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  getInjuryType = () => {
    dynamic
      .getAll('injurytype', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        this.setState({
          appInjuryType: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INJURYTYPE, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  setStaticObject = () => {
    registry
      .getAll('publicauthorities')
      .then((response) => {
        var data = response.data;
        data =
          data != null
            ? data.map((item) => ({
                id: item.name,
                name: item.name,
                specifyOther: item.specifyOther,
              }))
            : [];
        data.sort(function (a, b) {
          return a.code - b.code;
        });
        this.setState({
          appPublicAuthoritiesAndEntitiesInvolved: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PUBLICAUTHORITIES, apioperation.GET)
        );
      })
      .finally(() => {});

    // var appTransportAccident = [
    //     { id: 'No', text: 'No' },
    //     { id: 'AirTrasport', text: 'Air Trasport' },
    //     { id: 'RoadTraffic', text: 'Road Traffic' },
    //     { id: 'Ship/VesselTrasport', text: 'Ship/Vessel Trasport' },
    //     // { id: 'RollBar', text: 'Is the vehicle equipped with IVMS and Roll Bar' }
    // ];

    registry
      .getAll('transportaccident')
      .then((response) => {
        var data = response.data;
        data =
          data != null
            ? data.map((item) => ({
                id: item.name,
                text: item.name,
                specifyOther: item.specifyOther,
              }))
            : [];
        data.sort(function (a, b) {
          return a.code - b.code;
        });
        this.setState({
          appTransportAccident: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.TRANSPORTACCIDENT, apioperation.GET)
        );
      })
      .finally(() => {});

    dynamic
      .getAll('infooriginator', { params: { page: 0 } }) //RITM1197573
      .then((response) => {
        var data = _sortBy(response.data.itemList, "id"); //RITM1197573
        data = data != null ? data.map((item) => ({ id: item.name, name: item.name, inUse: item.inUse })) : []; //RITM1197573
        this.setState({
          appInfoOriginator: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INFOORIGINATOR, apioperation.GET)
        );
      })
      .finally(() => {});

    ReportRepository.getSubcontractors()
      .then((response) => {
        this.setState({
          subContractors: response,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.SUBCONTRACTOR, apioperation.get)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingSubContractorOptions: false,
        });
      });

    // var appWorkRelated = [
    //     { id: 'Yes', text: 'Yes' },
    //     { id: 'No', text: 'No' },
    //     { id: 'Communting', text: 'Communting', },
    // ];

    registry
      .getAll('workrelated')
      .then((response) => {
        var data = response.data;
        data =
          data != null
            ? data.map((item) => ({
                id: item.name,
                text: item.name,
                specifyOther: item.specifyOther,
              }))
            : [];
        data.sort(function (a, b) {
          return a.code - b.code;
        });
        this.setState({
          appWorkRelated: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKRELATED, apioperation.GET)
        );
      })
      .finally(() => {});

    // var appPlace = [
    //     { id: 'CampConstructionSite', text: 'Camp to Construction Site / viceversa' },
    //     { id: 'ResidenceplaceWorkplace', text: 'Residence place to Workplace / viceversa' },
    // ];

    dynamic
      .getAll('place', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;
        data = data != null ? data.map((item) => ({ id: item.name, text: item.name })) : [];

        this.setState({
          appPlace: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.PLACE, apioperation.GET)
        );
      })
      .finally(() => {});

  };

  //RITM1143712
  getIncidentTypology = () => {
    // this.setState({
    //   isLoadingIncident: true,
    // });
    dynamic
      .getAll('typology', { params: { page: 0 } })
      .then((response) => {
        const data = response.data.itemList;
        this.setState({
          appIncidentTypology: _sortBy(data, 'ranking'),
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.TYOPLOGY, apioperation.GET)
        );
      })
      .finally(() => {
        //   this.setState(
        //     {
        //         isLoadingIncident: false
        //     }
        // );
      });
    };

  //RITM1216061
  getIncidentHighConsequenceLevel = async () => {
    await dynamic
      .getAll('incidenthighconsequencelevel', { params: { page: 0 } })
      .then((response) => {			
      this.setState({
        appHighConsequenceLevels: response.data.itemList,
      });
      })
      .catch((error) => {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.HIGHCONSEQUENCE, apioperation.GET)
      );
      })
      .finally(() => {});
  }
  //End

  //RITM11405215
  getIncidentRealPotentialConsequenceLevel = async () => {
    await dynamic
      .getAll('incidentrealpotentialconsequencelevel', { params: { page: 0 } })
      .then((response) => {			
      this.setState({
        appRealPotentialConsequenceLevels: response.data.itemList,
      });
      })
      .catch((error) => {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.REALPOTENTIALCONSEQUENCE, apioperation.GET)
      );
      })
      .finally(() => {});
  }
  //End

  cancel = () => {
    this.props.history.push('/incident');
  };

  updateType = (dati) => {
    this.setState((prevState) => ({
      incidentEditModel: {
        ...prevState.incidentEditModel,
        tabNotifications: dati,
      },
    }));
  };
  //IP details counts error
  updateIncidentTabInvestigationModel = async (datiForm) => {
    this.setState((prevState) => ({
      incidentEditModel: {
        ...prevState.incidentEditModel,
        tabInvestigation: {...datiForm},
      },
    }));
  }
  //End
  updateCacheIncidentModel = async (datiForm, tab) => {
    if (tab == 'tabNotifications') {
      //aggiorno la lista degli incident quando viene modificato il tab notification
      var dati = datiForm;

      var result = [];
      if (dati.outcomeAsset != null && dati.outcomeAsset == true) result.push('Property/Asset');
      if (dati.outcomeEnvironmental != null && dati.outcomeEnvironmental == true)
        result.push('Environmental');
      if (dati.outcomeHarm != null && dati.outcomeHarm == true) result.push('Harm To People');

      var incidentDTO = {
        id: dati.id,
        idStatus: dati.idStatus,
        status: dati.status.reportingName,
        investigationLevel: dati.investigationLevel,
        incidentReportId: null,
        idDivision: dati.idDivision,
        division: dati.division,
        idWorksite: dati.idWorksite,
        worksite: (this.state.appAllWorksites || []).find((el) => el.id == dati.idWorksite)?.name,
        title: dati.title,
        occurrenceDate: moment.utc(dati.occurrenceDate).format('YYYY-MM-DD'),
        type: dati.type,
        outcomeAsset: dati.outcomeAsset,
        outcomeEnvironmental: dati.outcomeEnvironmental,
        outcomeHarm: dati.outcomeHarm,
        realOutcomeAsset: dati.realOutcomeAsset,
        realOutcomeEnvironmental: dati.realOutcomeEnvironmental,
        realOutcomeHarm: dati.realOutcomeHarm,
        outcome: result.join(','),
        idCompiler: dati.idCompiler,
        idDataApprover: dati.idDataApprover,
        idDivisionManager: dati.idDivisionManager,
      };

      if (!this.state.isEdit) {
        //in creazione inizializzo il modello per tutti i tab
        let statusCopy = {};

        statusCopy['tabNotifications'] = datiForm;

        statusCopy['tabReport'] = {
          noInjured: null,
          injuredPeople: [],
          eventCause: null,
          actions: null,
          dueDate: null,
          id: dati.id,
          progressiveId: undefined,
          incidentReportId: null,
          idStatus: dati.idStatus,
          status: dati.status,
          idCompiler: dati.idCompiler,
          idDataApprover: null,
          idDivisionManager: null,
        };

        statusCopy['tabInvestigation'] = {
          sourceAccident: null,
          spillLakeUM: null,
          spillLakeNumericValue: null,
          spillRiverUM: null,
          spillRiverNumericValue: null,
          spillSeaUM: null,
          spillSeaNumericValue: null,
          spillSoilUM: null,
          spillSoilNumericValue: null,
          spillSubstanceReleased: null,
          spillDescription: null,
          isUsedSpillKit: null,
          isInPlaceProcedure: null,
          airPollUM: null,
          airPollSubstanceReleased: null,
          airPollQuantityReleased: null,
          isFloraImpacted: null,
          isFaunaImpacted: null,
          incidentEvents: [],
          idWorkAreaType: null,
          idWorkProcessType: null,
          idEquipmentType: null,
          idWorkArea: null,
          idWorkProcess: null,
          idEquipment: null,
          light: null,
          lightOrigin: null,
          wheather: null,
          sea: null,
          temperature: null,
          temperatureType: null,
          windSpeed: null,
          noWitness: null,
          witnessPeople: [],
          investigationTeamMembers: [],
          attachment: [],
          id: dati.id,
          progressiveId: undefined,
          incidentReportId: null,
          idStatus: dati.idStatus,
          status: dati.status,
          idCompiler: dati.idCompiler,
          idDataApprover: null,
          idDivisionManager: null,
          isBarriersRestored: null, //RITM1405215
          investigationObjectives: null, //RITM1405215
          investigationScopeExclusion: null, //RITM1405215
          investigationMethodDetails: null, //RITM1405215
        };

        statusCopy['tabCauses'] = {
          investigationCriticalFactors: null,
          returnOfExperience: null,
          incidentCAR: [],
          id: dati.id,
          progressiveId: undefined,
          incidentReportId: null,
          idStatus: dati.idStatus,
          status: dati.status,
          idCompiler: dati.idCompiler,
          idDataApprover: null,
          idDivisionManager: null,
          timelineEventDescription: null, //RITM1405215
        };

        let carListModel = {
          id: datiForm.id,
          incidentCode: null,
          incident: {
            id: datiForm.id,
            progressiveId: undefined,
            incidentReportId: null,
            idStatus: dati.idStatus,
            status: dati.status,
            idCompiler: dati.idCompiler,
            idDataApprover: null,
            idDivisionManager: null,
          },
          incidentCAR: [],
        };

        await Promise.all([
          IncidentRepository.updateCachedIncidentList(incidentDTO),
          IncidentRepository.updateCachedIncident(datiForm.id, statusCopy, tab),
        ])
          .then((response) => {
            if(!this.state.isAutoOpenInjuredPerson){
            this.props.history.push('/incident/');
          }
          })
          .catch((error) => {
            console.error({ error });
          })
          .finally(() => {
            IncidentRepository.createCachedIncidentCAR(datiForm.id, carListModel);
          });
      } else {
        //RITM1420951
        // let statusCopy = Object.assign(this.state.incidentEditModel);
        // statusCopy['tabNotifications'] = datiForm;
        // console.log(statusCopy)
        //End
        this.setState({
          // incidentEditModel: statusCopy, //RITM1420951
          incidentEditModel: {
            ...this.state.incidentEditModel,
            tabNotifications: {...datiForm, incidentOutcomes: [...(datiForm.incidentOutcomes || [])]},
          }, //RITM1420951
          PHLFinalValue: this.state.appHighConsequenceLevels.find((el) => el.id == datiForm?.incidentOutcomes?.find(out => out.idOutcome == 0)?.idHighConsequenceLevelPotentialFinal)?.ranking, //RITM1519246
          PELFinalValue: this.state.appHighConsequenceLevels.find((el) => el.id == datiForm?.incidentOutcomes?.find(out => out.idOutcome == 2)?.idHighConsequenceLevelPotentialFinal)?.ranking, //RITM1519246
        }, () => {
          IncidentRepository.updateCachedIncidentList(incidentDTO);
          IncidentRepository.updateCachedIncident(datiForm.id, datiForm, tab);
        })        
      }
    } else {
      IncidentRepository.updateCachedIncident(datiForm.id, datiForm, tab);
    }
  };

  ///Status Action
  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  //RITM1216061
  handleCancelApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false, approver: null, isConsolidationActionNo: (((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
      || (this.state.incidentEditModel?.tabNotifications?.workRelated == 'Commuting' && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4)) 
      && (this.state.approvalModalAction == 'Consolidate' || this.state.approvalModalAction == 'Submit') && this.state.incidentEditModel?.tabNotifications?.idStatus == 1 ? true : false)}, this.clearApprovalForm); //RITM1519246 RITM1420951
   };
  //End

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
    };

  handleConfirmApprovalModal = () => {
    let action = this.state.approvalModalAction.toLowerCase();
    let apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.idIncidentEdit],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(this.baseUrl + apiEndpoint, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.INCIDENT, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isConsolidationActionNo: false, //RITM1216061
            isLoading: true,
            // model: null
          });
          this.props.history.push('/incident');
          //this.getIncidentForEdit(this.state.idIncidentEdit);
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.INCIDENT, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  IsRowSelectable() {
    var row = this.state.incidentEditModel;
    if (
      row == null ||
      row.tabNotifications == null ||
      (row.tabNotifications.idStatus == STATUS.Consolidated &&
       (!((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
       || (this.state.incidentEditModel?.tabNotifications?.workRelated == 'Commuting' && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4)))) /*RITM1216061*/ //RITM1519246 //RITM1420951
       )
      return false;

    return true;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    var incident = this.state.incidentEditModel.tabNotifications;

    if(actionKey == 'Submit' && (incident.lifeSavingRules === null || incident.lifeSavingRules?.length <= 0)) {
      this.setState({
        toSubmit: true
      })

      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        entitiesLabels.INCIDENT + ' required fields are missing  '
      );

      return;    
    }

    //RITM1519246
		if (!approvalNotesRequired && actionName != 'Delete' && (this.state.PHLFinalValue != null || this.state.PELFinalValue != null))
		{
			const ok = window.confirm("Do you confirm the HCA levels (AHC, PHCwc, PHCf) and the analysed safeguards (effective and inadequate)? Please before proceeding check the values in Notification tab");
 		    if (!ok) return;
		}
	//End

    var idWorksite =
      actionKey === 'Submit'
                ? incident.idWorksite
                : null; //RITM1064131
    var idDivision =
      actionKey === 'Approve'
                ? incident.idDivision
                : null; //RITM1064131

    this.setState({
      toSubmit: false,
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover: withApprover,
      selectedData: selectedRows,
      approverRole: approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired: approvalNotesRequired,
      isConsolidationActionNo: actionKey =='Consolidate' ? false : this.state.isConsolidationActionNo, //RITM1216061
    });

    if (withApprover) this.getUsersInRole(approverRole, 'Incident', idWorksite, idDivision); //RITM1064131
  }

  getUsersInRole = (role, appModule, idWorksite, idDivision) => { //RITM1064131
    me.getWithParam('getuserbyroleandmodule', { //RITM1064131
      params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROLE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    const idStatus = this.state.incidentEditModel.tabNotifications.idStatus;
    return (
      <Online>
        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Submit',
          this.state.incidentEditModel.tabNotifications
            ) && (( this.state.incidentEditModel?.tabNotifications?.outcomeAsset != null && this.state.incidentEditModel?.tabNotifications?.outcomeHarm == null
              && this.state.incidentEditModel?.tabNotifications?.outcomeEnvironmental == null) ? true :
              (!((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
              || (this.state.incidentEditModel?.tabNotifications?.workRelated == 'Commuting' && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4)))
              || this.state.isConsolidationActionNo == true) //RITM1216061 RITM1519246 RITM1420951
           ? (
          <Button
            renderIcon={Send16}
            onClick={() =>
              this.batchActionClick('Submit', 'Submit', 'Data Approver', true, false, null)
            }
          >
            Submit Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Approve',
          this.state.incidentEditModel.tabNotifications
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick('Approve', 'Approve', 'Division Manager', true, false, null)
              }
            >
              Approve Report
            </Button>
          ) : null}

        {((CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Consolidate',
          this.state.incidentEditModel.tabNotifications
            )) || (idStatus === 1 && ((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
               || (this.state.incidentEditModel?.tabNotifications?.workRelated == 'Commuting' && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4)))) 
          ? ( //RITM1519246 RITM1420951
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() =>
              this.batchActionClick('Consolidate', 'Consolidate', null, false, false, null) //RITM1216061
            }
          >
            Consolidate Report
          </Button>
        ) : null} {/*RITM1216061*/}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Reject',
          this.state.incidentEditModel.tabNotifications
        ) ? (
            <Button
              renderIcon={Error16}
              onClick={() => this.batchActionClick('Reject', 'Reject', null, false, true, null)}
            >
              Reject Report
            </Button>
          ) : null}
        {IsInRole(user, "Administrator") && idStatus === 4 
        ? (
          <Button
          renderIcon={Send16}
            onClick={() => this.batchActionClick("Reopen", "Reopen", null, false, false, null)}
          >
            Reopen Report
          </Button>
        ) : null} {/*RITM1216061*/}
        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'RejectConsolidate',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={Error16}
            onClick={() =>
              this.batchActionClick('RejectConsolidate', 'Reject', null, false, true, null)
            }
          >
            Reject Report
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'Reporting',
          user,
          idStatus,
          'Delete',
          this.state.incidentEditModel.tabNotifications
        ) ? (
          <Button
            renderIcon={Delete16}
            onClick={() => this.batchActionClick('Delete', 'Delete', null, false, false, null)}
          >
            Delete
          </Button>
        ) : null}
      </Online>
    );
  };
  ///Fine Status Action

  handleNotificationChange = (outcomeAsset, outcomeEnvironmental, outcomeHarm, realOutcomeHarm, realOutcomeAsset) => { //RITM1069073
    this.setState((prevState) => ({
      ...prevState,
      outcomeEnvironmental: outcomeEnvironmental,
      outcomeAsset: outcomeAsset,
      outcomeHarm: outcomeHarm,
      realOutcomeHarm: realOutcomeHarm,
      realOutcomeAsset: realOutcomeAsset, //RITM1069073
    }));
  };

  //RITM0864430
  updateAutoOpenInjuredPerson = (value) => {
    this.setState({isAutoOpenInjuredPerson: value });
};

  updateHarmedPeople = (value) => {
    this.getIncidentForEdit(this.state.idIncidentEdit);
  };

    
  updateEditMode = (value) => {
      this.setState({idIncidentEdit: value });
      this.getIncidentForEdit(this.state.idIncidentEdit);
  };

  //RITM1519246
  getphcfLevel = (phlFinalValue, pelFinalValue) => {
    if (phlFinalValue == null && pelFinalValue == null) return null;
    const phcf = (phlFinalValue == null && pelFinalValue != null) ? parseInt(pelFinalValue) : ((phlFinalValue != null && pelFinalValue == null) ? parseInt(phlFinalValue) : Math.max(parseInt(phlFinalValue), parseInt(pelFinalValue)));
    return !Number.isNaN(phcf) ? phcf : null;
  };
  //End

  render() {

    //RITM1617862
    //  const currentProject= {
    //   idProject:this.state.incidentEditModel?.tabNotifications.idProject ||'',
    //   idWorkSite:this.state.incidentEditModel?.tabNotifications.idWorksite||'',
    //   project: this.state.incidentEditModel?.tabNotifications.project||[]
    
    // };

    // // console.log ("===>", currentProject)
    // let  appAllWorksitePrj=[];
    // if (this.state.appAllWorksitePrj){
    //    appAllWorksitePrj=  this.state.appAllWorksitePrj?.find(el=>el.idProject===currentProject.id) ? this.state.appAllWorksitePrj : [...this.state.appAllWorksitePrj,currentProject];  
    //   }
    //End
        



    const tabNotificationProps = {
      key: 'tabNotif' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      isEdit: this.state.isEdit,
      toSubmit: this.state.toSubmit,
      incidentEditModel:
        this.state.incidentEditModel && this.state.incidentEditModel.tabNotifications,
      isLoadingIncident: this.state.isLoadingIncident,
      appActivity: this.state.appActivity || [],
      appPublicAuthoritiesAndEntitiesInvolved:
        this.state.appPublicAuthoritiesAndEntitiesInvolved || [],
      appTransportAccident: this.state.appTransportAccident || [],
      appInfoOriginator: this.state.appInfoOriginator || [],
      subContractors: this.state.subContractors || [],
      appWorkRelated: this.state.appWorkRelated || [],
      appPlace: this.state.appPlace || [],
      appLifeSavingRuleCategory: this.state.appLifeSavingRuleCategory || [],
      appLifeSavingRule: this.state.appLifeSavingRule || [],
      appAllWorksites: this.state.appAllWorksites,
	    //appAllWorksitePrj: appAllWorksitePrj, //RITM1617862
      appAllWorksitePrj: this.state.appAllWorksitePrj, //RITM1617862
      appIncidentTypology: this.state.appIncidentTypology || [], //RITM1143712
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      setlifeSavingRules: this.setlifeSavingRules,
      history: this.props.history,
      cancel: this.cancel,
      updateType: this.updateType,
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      onChange: this.handleNotificationChange,
      autoInjuredPersonModal: this.state.isAutoOpenInjuredPerson,//RITM0864430
      updateAutoOpenInjuredPerson: this.updateAutoOpenInjuredPerson,//RITM0864430
      updateEditMode: this.updateEditMode,
      updateHarmedPeople: this.updateHarmedPeople,
      tabInvestigation:
      this.state.incidentEditModel && this.state.incidentEditModel.tabInvestigation, //IP details counts error
      updateIncidentTabInvestigationModel: this.updateIncidentTabInvestigationModel, //IP details counts error
      appHighConsequenceLevels:	this.state.appHighConsequenceLevels || [], //RITM1216061
      appRealPotentialConsequenceLevels: this.state.appRealPotentialConsequenceLevels || [], //RITM1405215
    };

    const tabReportProps = {
      key: 'tabReport' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      incidentEditModel: this.state.incidentEditModel && this.state.incidentEditModel.tabReport,
      isLoadingIncident: this.state.isLoadingIncident,
      appInjuryType: this.state.appInjuryType || [],
      appCountry: this.state.appCountry || [],
      appType: this.state.appInfoOriginator || [],
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      history: this.props.history,
      cancel: this.cancel,
      submitReport: () =>
        this.batchActionClick('Submit', 'Submit', 'Data Approver', true, false, null),
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      isDisabled: this.state.isDisabledAll || false,
      isAccident:
        this.state.incidentEditModel && this.state.incidentEditModel.tabNotifications
          ? this.state.incidentEditModel.tabNotifications.realOutcomeHarm == true
          : false,
    };

    const tabInvestigationProps = {
      key: 'tabInvestigation' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      incidentEditModel:
        this.state.incidentEditModel && this.state.incidentEditModel.tabInvestigation,
      noInjuredPerson:
        this.state.incidentEditModel?.tabInvestigation?.noInjured != null
          ? this.state.incidentEditModel?.tabInvestigation?.noInjured
          : this.state.incidentEditModel?.tabNotifications?.realOutcomeHarm,
      isLoadingIncident: this.state.isLoadingIncident,
      appType: this.state.appInfoOriginator || [],
      subContractors: this.state.subContractors || [],
      appInjuryType: this.state.appInjuryType || [],
      appCountry: this.state.appCountry || [],
      outcomeEnviroment:
        this.state.outcomeEnvironmental !== undefined
          ? this.state.outcomeEnvironmental
          : this.state.incidentEditModel?.tabNotifications?.outcomeEnvironmental
          ? true
          : false,
      outcomeAsset:
        this.state.outcomeAsset !== undefined
          ? this.state.outcomeAsset
          : this.state.incidentEditModel?.tabNotifications?.outcomeAsset
          ? true
          : false,
      outcomeHarm:
        this.state.outcomeHarm !== undefined
          ? this.state.outcomeHarm
          : this.state.incidentEditModel?.tabNotifications?.outcomeHarm
          ? true
          : false,
      realOutcomeHarm:
        this.state.realOutcomeHarm !== undefined
          ? this.state.realOutcomeHarm
          : this.state.incidentEditModel?.tabNotifications?.realOutcomeHarm
          ? true
          : false,
      realOutcomeAsset: //RITM1069073
        this.state.realOutcomeAsset !== undefined
          ? this.state.realOutcomeAsset
          : this.state.incidentEditModel?.tabNotifications?.realOutcomeAsset
          ? true
          : false,
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      history: this.props.history,
      cancel: this.cancel,
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      isDisabled: this.state.isDisabledAll || false,
      autoInjuredPersonModal: this.state.isAutoOpenInjuredPerson,//RITM0864430
      updateAutoOpenInjuredPerson: this.updateAutoOpenInjuredPerson,
      updateHarmedPeople: this.updateHarmedPeople,
      updateIncidentTabInvestigationModel: this.updateIncidentTabInvestigationModel, //IP details counts error
      /*NF ID: RITM1216061 || Task - 1 || Sub-Task-1 || Vasudevan */
      tabNotificationAHLorPHLProps: tabNotificationProps?.incidentEditModel?.incidentOutcomes.some(item => item.idHighConsequenceLevelPotentialFinal != null) ? true : null,
      appHighConsequenceLevels:	this.state.appHighConsequenceLevels || [], //RITM1216061
      isConsolidationActionNo: this.state.isConsolidationActionNo, //RITM1216061
      outcomeModel: this.state.incidentEditModel?.tabNotifications?.incidentOutcomes, //RITM1216061
      workRelated: this.state.incidentEditModel?.tabNotifications?.workRelated, //RITM1420951
    };

    const tabCausesProps = {
      key: 'tabCauses' + (this.state.incidentEditModel ? 'Edit' : 'Add'),
      incidentEditModel: this.state.incidentEditModel && this.state.incidentEditModel.tabCauses,
      isLoadingIncident: this.state.isLoadingIncident,
      selectTab: this.selectTab,
      isSubmitted: this.isSubmitted,
      history: this.props.history,
      cancel: this.cancel,
      updateCacheIncidentModel: this.updateCacheIncidentModel,
      isDisabled: this.state.isDisabledAll || false,
      appHighConsequenceLevels:	this.state.appHighConsequenceLevels || [], //RITM1405215
      isConsolidationActionNo: this.state.isConsolidationActionNo, //RITM1405215
      outcomeModel: this.state.incidentEditModel?.tabNotifications?.incidentOutcomes, //RITM1405215
      workRelated: this.state.incidentEditModel?.tabNotifications?.workRelated, //RITM1420951
    };
   
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={!this.state.isEdit ? '/incident' : '/incident?isBack'}
              linkText="Incidents"
              titleLeft={this.state.isEdit ? 'Edit Incident' : 'New Incident'}
              titleCenter={
                this.state.incidentEditModel &&
                'ID: ' + this.state.incidentEditModel.tabNotifications.incidentReportId
              }
              titleRight={
                this.state.incidentEditModel && this.state.incidentEditModel.tabNotifications.status
                  ? this.state.incidentEditModel.tabNotifications.status.reportingName
                  : null
              }
              batchActions={this.getStatusActions(user)}
              showButtonHistory={this.state.isEdit ? this.showButtonHistory() : null}
            />
            <div className="mainContainer">
                  
              {/* RITM0655780 */}
              { !(this.state.incidentEditModel 
                && this.state.incidentEditModel.tabNotifications 
                && this.state.incidentEditModel.tabNotifications.notificationDate 
                && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
              ) ? (
                ''
              ) : this.state.isLoadingIncident ? (
                <div className="bx--col-lg-12 bx--tab-container">
                  <TabsSkeleton className="bannerNotification" />
                </div>
              ) : (
                <div className="bx--row">
                  <InlineNotification
                    kind={'warning'}
                    lowContrast={true}
                    title={'Warning'}
                    subtitle={'The Incident Notification has not been sent!'}
                    iconDescription=""
                    hideCloseButton="true"
                    style={{ maxWidth: 'none' }}
                  />
                </div>
              )}
              {/* END RITM0655780 */}

              <div className="bx--grid content full-width">
                {this.showLoading()}
                <WFActionModal
                  show={this.state.isApprovalModalOpen}
                  title={`${this.state.approvalModalAction} Incidents`}
                  action={this.state.approvalModalAction}
                  withApprover={this.state.withApprover}
                  approver={this.state.approver}
                  approverRole={this.state.approverRole}
                  approverOptions={this.state.approvers}
                  isLoadingOperation={this.state.isLoadingWFOperation}
                  onApproverSelect={this.handleApproverSelect}
                  isLoadingOptions={this.state.isLoadingApproverOptions}
                  onCancel={this.handleCancelApprovalModal} //RITM1216061
                  onConfirm={this.handleConfirmApprovalModal}
                  onApprovalNotesChange={this.handleApprovalNotesChange}
                  approvalNotes={this.state.approvalNotes}
                  approvalNotesRequired={this.state.approvalNotesRequired}
                  validationMessages={this.state.approvalValidationMessages}
                  customMessage={(((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) || (this.state.incidentEditModel?.tabNotifications?.workRelated == 'Commuting' && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4)) && this.state.incidentEditModel?.tabNotifications?.idStatus == 1 && this.state.approvalModalAction == 'Consolidate') ? `Do you want to complete without Incident Investigation?` : null} //RITM1216061 RITM1519246 RITM1420951
                  customMessage2={(((this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) || (this.state.incidentEditModel?.tabNotifications?.workRelated == 'Commuting' && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) > 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) < 4)) && this.state.incidentEditModel?.tabNotifications?.idStatus == 1 && this.state.approvalModalAction == 'Consolidate') ? `NOTE: Investigation report is not required for PHCf_people/PHCf_env 0-1 and for Commuting Events with PHCf_People/PHCf Env 0,1,2,3\nif confirm is clicked, report will be completed without distribution\nif cancel is clicked, the usual full investigation report will be enabled` : null} //RITM1216061 RITM1519246 RITM1420951
                  module={'Incident'} //RITM1216061
                  onClose={this.handleCloseApprovalModal} //RITM1216061
                  user={user} //RITM1064131
                />
                {this.state.isEdit ? (
                  <HistoryTable
                    entityId={this.state.idIncidentEdit}
                    isOpenModal={this.state.isHistoryModalOpen}
                    onClose={() => this.closeModalHistory()}
                    masked={this.state.incidentEditModel?.tabNotifications.maskedValue} //RITM0946001 - Anonimizzazione Modulo Incident
                  />
                ) : (
                  ''
                )}
                <form
                  autoComplete="off"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <div className=" bx--row">
                    <div className="bx--col-lg-12 bx--tab-container bx--tab--conteiner-incident">
                      <Tabs
                        selected={this.state.stateTabs}
                        onSelectionChange={(index) => this.setState({ stateTabs: index })}
                        tabContentClassName="tab-content"
                      >
                        <Tab key="tab_0" disabled={false} label="1.Notification" tabIndex={0}>
                          <ScrollingProvider key="scroll_0">
                            <IncidentTabNotification {...tabNotificationProps} user={user} />
                          </ScrollingProvider>
                        </Tab>
                        <Tab
                          key="tab_1"
                          disabled={!this.state.isEdit || (this.state.incidentEditModel 
                            && this.state.incidentEditModel.tabNotifications 
                            && this.state.incidentEditModel.tabNotifications.notificationDate 
                            && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
                          )}
                          label="2.Investigation"
                          tabIndex={2}
                        >
                          <ScrollingProvider>
                            {this.state.isEdit && this.state.incidentEditModel && (
                              <IncidentTabInvestigation {...tabInvestigationProps} user={user} />
                            )}
                          </ScrollingProvider>
                        </Tab>
                        <Tab
                          key="tab_2"
                          disabled={!this.state.isEdit || (this.state.incidentEditModel 
                            && this.state.incidentEditModel.tabNotifications 
                            && this.state.incidentEditModel.tabNotifications.notificationDate 
                            && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
                          )}
                          label="3.Causes"
                          tabIndex={3}
                        >
                          <ScrollingProvider>
                            {this.state.isEdit && this.state.incidentEditModel && (
                              <IncidentTabCauses {...tabCausesProps} user={user} />
                            )}
                          </ScrollingProvider>
                        </Tab>
                        <Tab
                          key="tab_3"
                          disabled={!this.state.isEdit || (this.state.incidentEditModel 
                            && this.state.incidentEditModel.tabNotifications 
                            && this.state.incidentEditModel.tabNotifications.notificationDate 
                            && this.state.incidentEditModel.tabNotifications.notificationDate.startsWith('0001-01-01')
                          )}
                          label="4.Report distribution"
                          tabIndex={1}
                        >
                          <ScrollingProvider>
                            {this.state.isEdit && this.state.incidentEditModel && (
                              <IncidentTabReport {...tabReportProps} user={user} />
                            )}
                          </ScrollingProvider>
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
